const React = require('react');

const EditIcon = require('@material-ui/icons/Edit').default;
const EnrollIcon = require('@material-ui/icons/ReceiptOutlined').default;
const PlayCircleIcon = require('@material-ui/icons/PlayCircleOutlineOutlined').default;
const CancelIcon = require('@material-ui/icons/CancelOutlined').default;

const IconButton = require('@material-ui/core/IconButton').default;

const RowA = require('../../../../../../../dumb/Row/A');
const ColA = require('../../../../../../../dumb/Col/A');
const ColA2 = require('../../../../../../../dumb/Col/A2');
const Tooltip = require('../../../../../../../dumb/Tooltip/A');

const formatCCSymbol = require("../../../../../../../../utils/formatCCSymbol");
const {AdminTimeCell} = require("../../../../../../../dumb/TableTimeCell");
const {TableNumberColAmin} = require("../../../../../../../dumb/TableNumberCol");
const {
  DisplayDataAdmin,
  DisplayIdAdmin,
  DisplayAmountAdmin,
  DisplayHashAdmin,
  DisplayDateTimeAdmin
} = require("../../../../../../../dumb/DisplayData");
const upperFirst = require("mn-utils/upperFirst");
const openEditCustomerRefundPopup = require("../../utils/openEditCustomerRefundPopup");
const openStartCustomerRefundPopup = require("../../utils/openStartCustomerRefundPopup");
const openStatusCustomerRefundPopup = require("../../utils/openStatusCustomerRefundPopup");
const openDeclineCustomerRefundPopup = require("../../utils/openDeclineCustomerRefundPopup");
const getExplorerUrlPrefixByCoin = require("../../../../../../../../utils/getExplorerUrlPrefixByCoin");

const RowAction = ({title, action, icon: IC, disabled}) => {
  const btn = (
    <IconButton
      className="olN-i (o20):disabled"
      onClick={action}
      disabled={disabled}
    >
      <div className="sq23 layoutRow fhaC fvaC cF">
        {IC && <IC />}
      </div>
    </IconButton>
  )

  return disabled
    ? btn
    : (
      <Tooltip title={title} disabledCopy>
        {btn}
      </Tooltip>
    )
}

module.exports = ({data, update}) => {
  const id = data.id || '';
  const hash = data.tx_hash || '';
  const email = data.buyer_email || '';
  const created = data.created_at || '';
  const resolved = data.resolved_at || '';
  const fiatAmount = data.fiat_amount || '';
  const fiatCode = data.fiat_code || '';
  const ccAmount = data.cc_amount || '';
  const ccCode = data.cc_code || '';
  const network = data.network || '';
  const lifeflow = data.lifeflow || '';
  const auctionId = data.auction_id || '-';

  const refundLifeflow = data.refund_lifeflow;
  const refundStatus = data.refund_status;


  if (email === '222@vvv.ewr') {
    // console.log(formatNumFiat(fiatAmount));
    // console.log(fiatAmount);
  }

  const disableActions = !lifeflow || !['created', 'deposit_checking', 'refund_possible'].includes(lifeflow);

  const refundStatuses = {
    withdrawal_done: 'refund_completed',
    canceled: 'refund_failed',
    active: 'refund_active',
  }

  const ccSymbol = network ? [network.toUpperCase(), ccCode].join('_') : ccCode;

  const status = refundLifeflow || refundStatus
    ? (refundStatuses[refundLifeflow] || refundStatuses[refundStatus])
    : lifeflow;

  return (
    <div className="dB w olN tdN cF dn bgF1:h">
      <RowA className="f12">
        <ColA className="wmin155 fx1">
          <DisplayIdAdmin>{id}</DisplayIdAdmin>
        </ColA>
        <ColA className="wmin180 fx1">
          <DisplayHashAdmin symbol={ccSymbol} hash={hash} />
        </ColA>
        <ColA className="wmin150 fx1">
          <DisplayDataAdmin>{email}</DisplayDataAdmin>
        </ColA>
        <ColA className="wmin95">
          <DisplayDateTimeAdmin date={created} />
        </ColA>
        <ColA className="wmin95">
          <DisplayDateTimeAdmin date={resolved} />
        </ColA>
        {/*<ColA className="wmin150 fx1">*/}
        {/*  <TableNumberColAmin*/}
        {/*    value={fiatAmount}*/}
        {/*    symbol={fiatCode}*/}
        {/*    type="fiat"*/}
        {/*  />*/}
        {/*</ColA>*/}
        <ColA className="wmin150 fx1">
          <DisplayAmountAdmin
            amount={ccAmount}
            symbol={formatCCSymbol(ccSymbol)}
            type="coin"
          />
        </ColA>
        <ColA className="wmin155 fx1">
          <DisplayIdAdmin>{auctionId}</DisplayIdAdmin>
        </ColA>
        <ColA className="wmin150 fx1">
          {status ? upperFirst(status.includes('_') ? status.split('_').join(' ') : status) : ''}
        </ColA>
        {/*<ColA2 className="w56">*/}
        {/*  <Tooltip title="Enroll" disabledCopy>*/}
        {/*    <IconButton*/}
        {/*      className="olN-i"*/}
        {/*      onClick={() => openEnrollCustomerRefundPopup(data, update)}*/}
        {/*    >*/}
        {/*      <div className="sq23 layoutRow fhaC fvaC cF">*/}
        {/*        <EnrollIcon />*/}
        {/*      </div>*/}
        {/*    </IconButton>*/}
        {/*  </Tooltip>*/}
        {/*</ColA2>*/}
        <ColA2 className="w56">
          <RowAction
            title="Start Refund"
            action={() => openStartCustomerRefundPopup(data, update)}
            // action={() => openStatusCustomerRefundPopup(data, update)}
            icon={PlayCircleIcon}
            disabled={status !== 'refund_possible'}
          />
        </ColA2>
        <ColA2 className="w56">
          <RowAction
            title="Edit"
            action={() => openEditCustomerRefundPopup(data, update)}
            icon={EditIcon}
            disabled={disableActions}
          />
        </ColA2>
        <ColA2 className="w56">
          <RowAction
            title="Cancel"
            action={() => openDeclineCustomerRefundPopup(data, update)}
            icon={CancelIcon}
            disabled={disableActions}
          />
        </ColA2>
      </RowA>
    </div>
  );
};
